import { usePageParamsFromSchema } from 'src/hooks/use-page-params-from-schema';
import { getOperatorsOverviewPageParamsForOperatorsListSchema } from 'src/pages/operators/assignments/overview/schema';

export function useOperatorsOverviewPageParams() {
  return usePageParamsFromSchema(
    getOperatorsOverviewPageParamsForOperatorsListSchema(),
    {
      filters: {
        operatorId: { label: 'Operator' },
        organisationAssignmentStatus: {
          label: 'Organisation Assignment Status',
        },
        tradingMarket: { label: 'Market' },
        userName: { label: 'Name' },
        userEmail: { label: 'Email' },
        userAssignmentStatus: { label: 'User Assignment Status' },
      },
    }
  );
}

export type OperatorsOverviewPageParams = ReturnType<
  typeof useOperatorsOverviewPageParams
>;

export type SearchParams = OperatorsOverviewPageParams['value'];
